import React from "react"
import {
  Link,
  Redirect,
  Switch,
  Route,
  useHistory,
  useRouteMatch,
} from "react-router-dom"

import { Box, IconButton, Tabs, Tab } from "@material-ui/core"
import { ArrowBackRounded as ArrowBackRoundedIcon } from "@material-ui/icons"
import { InsetWrap, Title } from "@citydna/common"

import { useData } from "../common/DataProvider"
import { SchemaEditor } from "./SchemaEditor"
import { SettingsEditor } from "./SettingsEditor"

/**
 * Outstanding issues:
 * - form resets after submit
 */

export const FeatureLayerSettings: React.FC = () => {
  /** Grab the currently active feture layer */
  const {
    activeFeatureLayer: [featureLayer],
  } = useData()

  const history = useHistory()
  const match = useRouteMatch<{
    layerId: string
    settingsPage: "definition" | "schema"
  }>("/layers/:layerId/settings/:settingsPage?")

  return (
    <Box flexGrow={1} overflow="scroll">
      <InsetWrap>
        <Box display="flex" mb={2}>
          <IconButton component={Link} to={`/layers/${featureLayer?.id}`}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Title
            loading={!featureLayer}
            primary={featureLayer?.title}
            secondary="Settings"
            flexGrow={1}
            maxWidth={840}
          />
        </Box>
        <Box mb={2}>
          <Tabs
            indicatorColor="secondary"
            value={match?.params.settingsPage || "definition"}
            onChange={(_, page) =>
              history.push(`/layers/${match?.params.layerId}/settings/${page}`)
            }
          >
            <Tab value="schema" label="Schema" />
            <Tab value="definition" label="Definition" />
          </Tabs>
        </Box>
        <Switch>
          <Route path="/layers/:layerId/settings/schema">
            <SchemaEditor />
          </Route>
          <Route path="/layers/:layerId/settings/definition">
            <SettingsEditor />
          </Route>
          <Redirect to={`/layers/${match?.params.layerId}/settings/schema`} />
        </Switch>
      </InsetWrap>
    </Box>
  )
}
